<template>
  <v-container
    id="profiles-table"
    fluid
    tag="section"
  >
    <base-material-card
      icon="mdi-account-group"
      title=""
      class="px-5 py-3"
    >
      <br>

      <v-data-table
        :headers="profileTableHeaders"
        :items="profiles"
        item-key="id"
        class="elevation-1"
        :loading="isProfilesTableLoading"
      >
      <template v-slot:item.canAccessProjects="{ item }">  
        <v-icon v-if="hasAnyPermissionTrue(item.Proyectos)" color="green">
            mdi-check
        </v-icon>
      </template>

      <template v-slot:item.canAccessContacts="{ item }">
        <v-icon v-if="hasAnyPermissionTrue(item.Contactos)" color="green">
          mdi-check
        </v-icon>
      </template>

      <template v-slot:item.canAccessUsers="{ item }">
        <v-icon v-if="hasAnyPermissionTrue(item.Usuarios)" color="green">
          mdi-check
        </v-icon>
      </template>

      <template v-slot:item.canAccessProfiles="{ item }">
        <v-icon v-if="hasAnyPermissionTrue(item.Perfiles)" color="green">
          mdi-check
        </v-icon>
      </template>

      <template v-slot:item.canAccessVisits="{ item }">
        <v-icon v-if="hasAnyPermissionTrue(item.Visitas)" color="green">
          mdi-check
        </v-icon>
      </template>
      
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-if="$store.getters.hasPermission('Perfiles', 'Editar')">
                <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="chargeEditProfile(item)">
                  mdi-pencil
                </v-icon>
              </div>
            </template>
            <span>Editar Permisos del Perfil</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-if="$store.getters.hasPermission('Perfiles', 'Eliminar')">
                <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="deleteProfile(item)">
                  mdi-trash-can-outline
                </v-icon>
              </div>
            </template>
            <span>Borrar Perfil</span>
          </v-tooltip>
        </template>
        
      </v-data-table>
    </base-material-card>

    <v-fab-transition>
      <v-btn
        v-if="$store.getters.hasPermission('Perfiles', 'Crear')"
        class="mb-10 fab-button"
        fab
        color="blue darken-2"
        bottom
        right
        absolute
        fixed
        @click=chargeEmptyProfile()
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>
    
    <v-row justify="center">
     <formulario-perfiles 
     :isEditMode="isEditMode" 
     :profileData="profileData" 
     :isProfileDialogVisible="isProfileDialogVisible" 
     :isProfileFormValid="isProfileFormValid" 
     :isProfileButtonLoading="isProfileButtonLoading"
     @update:isProfileDialogVisible="isProfileDialogVisible = $event"
     @submit-profile="handleSubmitProfile">
     </formulario-perfiles>
    </v-row>

    <v-row justify="center">
      <v-dialog
        v-model="isDeleteProfileDialogVisible"
        max-width="500"
      >
        <v-card>
          <v-card-title class="text-h5">
            Eliminar perfil
          </v-card-title>
          <v-card-text>
            ¿Estás seguro que deseas eliminar este perfil?
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="danger"
              text
              @click="isDeleteProfileDialogVisible = false"
            >
              No
            </v-btn>
            <v-btn
              color="primary"
              text
              :loading="isDeleteButtonLoading"
              @click="confirmDeleteProfile()"
            >
              Sí
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

  </v-container>
</template>
  
<script>
import firebase from 'firebase/app'
import FormularioPerfiles from './components/FormularioPerfiles.vue'
export default {
  components: {
    FormularioPerfiles
  },
  data() {
    return {
      profileIdToDelete: '',
      isEditMode:false,
      isProfileFormValid: true,
      isProfilesTableLoading: true,
      isProfileButtonLoading: false,
      isDeleteButtonLoading: false,
      isProfileDialogVisible: false,
      isDeleteProfileDialogVisible: false,
      profileData : {
        Perfil: '',
        Proyectos: {
          Crear: false,
          Editar: false,
          Eliminar: false,
          Descargar: false,
          Negociación: false,
          Aprobación: false,
          Prospección: false,
          VerTodo: false
        },
        Contactos: {
          Crear: false,
          Editar: false,
          Eliminar: false,
          Descargar: false,
          VerMódulo: false
        },
        Usuarios: {
          Crear: false,
          Editar: false,
          Eliminar: false,
          VerMódulo: false
        },
        Perfiles: {
          Crear: false,
          Editar: false,
          Eliminar: false,
          VerMódulo: false
        },
        Visitas: {
          VerMódulo: false,
          VerHistorialDeCambios:false,
        },
      },
      profiles: [],
      profileTableHeaders: [
        { text: 'Perfil', align: 'start', sortable: false, value: 'Perfil' },
        { text: 'Proyectos', value: 'canAccessProjects' },
        { text: 'Contactos', value: 'canAccessContacts' },
        { text: 'Usuarios', value: 'canAccessUsers' },
        { text: 'Perfiles', value: 'canAccessProfiles' },
        { text: 'Visitas', value: 'canAccessVisits' },
        { text: 'Acciones', value: 'actions', sortable: false }
      ],
    };
  },
  mounted() {
    this.getProfiles()
  },
  methods: {
    getProfiles() {
      this.profiles = []
      this.isProfilesTableLoading = true
      firebase.firestore().collection('perfiles').get().then(profiles => {
        profiles.forEach(profile => {
          const dataProfile = profile.data()
          this.profiles.push({
            id: profile.id,
            ...dataProfile
          })
        })
        this.isProfilesTableLoading = false
      }).catch(() => {
        this.isProfilesTableLoading = false
      })
    },
    hasAnyPermissionTrue(modulo) {
      return Object.values(modulo || {}).some(v => v === true)
    },
    chargeEmptyProfile(){
      this.resetProfileData();
      this.isProfileDialogVisible=true;
    },
    chargeEditProfile(item) {
      const baseProfile = {
        Perfil: item.Perfil || '',
        Proyectos: {
          Crear: false,
          Editar: false,
          Eliminar: false,
          Descargar: false,
          Negociación: false,
          Aprobación: false,
          Prospección: false,
          VerTodo: false
        },
        Contactos: {
          Crear: false,
          Editar: false,
          Eliminar: false,
          Descargar: false,
          VerMódulo: false
        },
        Usuarios: {
          Crear: false,
          Editar: false,
          Eliminar: false,
          VerMódulo: false
        },
        Perfiles: {
          Crear: false,
          Editar: false,
          Eliminar: false,
          VerMódulo: false
        },
        Visitas: {
          VerMódulo: false,
          VerHistorialDeCambios:false,
        },
      };
      this.profileData = {
        ...baseProfile,
        Proyectos: { ...baseProfile.Proyectos, ...item.Proyectos },
        Contactos: { ...baseProfile.Contactos, ...item.Contactos },
        Usuarios: { ...baseProfile.Usuarios, ...item.Usuarios },
        Perfiles: { ...baseProfile.Perfiles, ...item.Perfiles },
        Visitas: { ...baseProfile.Visitas, ...item.Visitas }
      };
      this.isEditMode = true;
      this.isProfileDialogVisible = true;
    },
    deleteProfile(Profile) {
      this.profileIdToDelete = Profile.id
      this.isDeleteProfileDialogVisible = true
    },
    confirmDeleteProfile() {
      this.isDeleteButtonLoading = true
      firebase.firestore().collection('perfiles').doc(this.profileIdToDelete).delete().then(() => {
        this.isDeleteButtonLoading = false
        this.isDeleteProfileDialogVisible = false
        this.getProfiles()
      }).catch(() => {
        this.isDeleteButtonLoading = false
      })
    },
    handleSubmitProfile(profileData) {
      this.isProfileButtonLoading = true;
      const profileRef = firebase.firestore().collection('perfiles').doc(profileData.Perfil.trim());
      const operation = this.isEditMode
        ? profileRef.update(profileData)
        : profileRef.set(profileData);

      operation
        .then(() => {
          this.isProfileButtonLoading = false;
          this.isProfileDialogVisible = false;
          this.getProfiles();
          this.resetProfileData();
        })
        .catch(() => {
          this.isProfileButtonLoading = false;
        });
    },
    resetProfileData() {
      this.profileData = {
        Perfil: '',
        Proyectos: {
          Crear: false,
          Editar: false,
          Eliminar: false,
          Descargar: false,
          Negociación: false,
          Aprobación: false,
          Prospección: false,
          VerTodo: false
        },
        Contactos: {
          Crear: false,
          Editar: false,
          Eliminar: false,
          Descargar: false,
          VerMódulo: false
        },
        Usuarios: {
          Crear: false,
          Editar: false,
          Eliminar: false,
          VerMódulo: false
        },
        Perfiles: {
          Crear: false,
          Editar: false,
          Eliminar: false,
          VerMódulo: false
        },
        Visitas: {
          VerMódulo: false,
          VerHistorialDeCambios:false,
        },
      }
      this.isEditMode = false
    },
  }
}
</script>

<style scoped>
.fab-button {
  margin-right: -.5rem !important
}
</style>